import { NgModule } from '@angular/core';
import { HttpModule, XHRBackend, RequestOptions } from '@angular/http';

import { authHttpFactory } from './auth-http-factory.function';
import { AuthHttpService } from './auth-http.service';

@NgModule({
  imports: [
    HttpModule
  ],
  providers: [
    {
      provide: AuthHttpService,
      useFactory: authHttpFactory,
      deps: [XHRBackend, RequestOptions]
    }
  ],
  declarations: []
})
export class AuthorizationModule { }



// WEBPACK FOOTER //
// /dist/src/app/security/authorization/authorization.module.ts